(() => {
  const SECTION_SELECTOR = ".media-cards";
  const INIT_ATTR = "data-media-cards-initialized";

  /**
   * @param {HTMLElement} sectionCards
   */
  const initMediaCardsSection = (sectionCards) => {
    if (!sectionCards || sectionCards.hasAttribute(INIT_ATTR)) return;
    sectionCards.setAttribute(INIT_ATTR, "true");

    const grid = sectionCards.querySelector(".media-cards__grid");
    if (!(grid instanceof HTMLElement)) return;

    /** @type {HTMLElement[]} */
    const cards = [...sectionCards.querySelectorAll(".media-card")].filter(
      (el) => el instanceof HTMLElement,
    );
    if (!cards.length) return;

    /**
     * @param {HTMLElement} card
     */
    const updateCardTextHeight = (card) => {
      const text = card.querySelector(".media-card__text");
      const textHeight = text instanceof HTMLElement ? text.offsetHeight : 0;
      card.style.setProperty("--card-text-height", `${textHeight}px`);
    };

    const updateGridHeight = () => {
      if (window.innerWidth <= 749) {
        grid.style.removeProperty("--media-cards-grid-height");
        return;
      }

      let maxHeight = 0;

      cards.forEach((card, index) => {
        const stackIndex =
          Number.parseFloat(card.style.getPropertyValue("--i")) ||
          cards.length - index - 1;
        const cardBottom = card.offsetHeight + stackIndex * 100;
        if (cardBottom > maxHeight) maxHeight = cardBottom;
      });

      grid.style.setProperty("--media-cards-grid-height", `${Math.ceil(maxHeight)}px`);
    };

    cards.forEach((card) => updateCardTextHeight(card));
    updateGridHeight();

    const resizeObserver = new ResizeObserver(() => {
      cards.forEach((card) => updateCardTextHeight(card));
      updateGridHeight();
    });

    cards.forEach((card) => resizeObserver.observe(card));

    const target = sectionCards.querySelector(".media-cards__content");
    if (!target) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const totalCards = cards.length;
          cards.forEach((card, index) => {
            const reverseIndex = totalCards - index - 1;
            setTimeout(() => {
              card.classList.add("is-active");
            }, reverseIndex * 350);
          });

          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        threshold: 0,
        rootMargin: "-20% 0px -40% 0px",
      },
    );

    observer.observe(target);
  };

  const initAllMediaCardsSections = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach((sectionCards) => {
      if (sectionCards instanceof HTMLElement) initMediaCardsSection(sectionCards);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllMediaCardsSections, {
      once: true,
    });
  } else {
    initAllMediaCardsSections();
  }

  document.addEventListener("shopify:section:load", initAllMediaCardsSections);
})();
